import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
//eslint-disable-next-line
import { Button, List } from '@material-ui/core';
import { remove } from 'lodash';
import PrescriptionItem from './PrescriptionItem';
import PharmacyListModal from '../PharmacyListModal';
import LoadingSpinner from '../../../components/LoadingSpinner';
import Modal from '../../../components/Modal';
import { useStateAuthValue } from '../../../context/Auth/AuthState';
import { useToast } from '../../../context/Toast/ToastProvider';
import { PrescriptionType } from '../../../models/enums';
import { GetPrescriptions } from '../../../services/prescriptionService';
import ConsultationData from '../../historyClinic/HistoryClinicDetail/consultationData';
import { getPatientFamilyGroupConsultations } from '../../../services/consultationService';
import { GetProfessional } from "../../../services/professionalService";
import { formatDateHour } from '../../../utils/DateUtil';
import { textByPrescriptionType } from '../../../utils/PrescriptionUtil';
import { showToast, ToastType } from '../../../utils/ToastUtil';


const PrescriptionFamilyGroupList = ({ filterStatus }) => {
   const toastDispatch = useToast();
   const [{ userToken, userData }] = useStateAuthValue();
   const [prescriptionListTitular, setPrescriptionListTitular] = useState([]);
   const [prescriptionListFam, setPrescriptionListFam] = useState([]);
   const [loading, setLoading] = useState(true);
   const [modalPharmacy, setModalPharmacy] = useState(false);
   const [selectedPrescription, setSelectedPrescription] = useState([]);
   const professionalProfiles = {};

   const showError = (msgError) => {
      showToast(toastDispatch, msgError, ToastType.ERROR, ToastType.ERROR);
   };

   const [consultations, setConsultations] = useState([]);

   const getPatientName = (login) => {
      if (login === userData?.email) {
         return userData?.first_name + " " + userData?.last_name;
      }
      const [email, idNumber] = (login || '').split('#');
      const member = userData?.patient_dto?.family_group?.find(
         (f) => (f.email && f.email === login) || (idNumber && String(f.id_number) === idNumber && email === userData?.email)
      );
      return member ? member.first_name + " " + member.last_name : login;
   };

   useEffect(() => {
      setLoading(false);
   }, [userToken, userData]);

   useEffect(() => {
      if (!userToken) return;
      getPatientFamilyGroupConsultations(userToken, { page: 0, size: 10, sort: 'createdDate,desc' })
         .then((response) => setConsultations(Array.isArray(response) ? response : []))
         .catch(() => showError('Ocurrió un error en la búsqueda de las consultas'));
      // eslint-disable-next-line
   }, [userToken]);

  const history = useHistory();

  const irAHistoriaClinica = (idPaciente) => {
    history.push(`/historia-clinica/${idPaciente}`);
  };

   return (
      <>
         <div className="prescription-list">
          
            {consultations.map((c) => (
               <div key={c.id} className="family-consultation-item">
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 32px' }}>
                     <p>Fecha: {formatDateHour(c.createdDate)}</p>
                     <p>Paciente: {getPatientName(c.patientLogin)}</p>
                     <p>Consulta Nro.: {c.consultationId}</p>
                  </div>
                  <ConsultationData
                     data={{
                        ...c,
                        creation_date: c.createdDate,
                        consultation_type: c.consultationType,
                        affiliate_number: c.affiliateNumber,
                     }}
                     isPatient={true}
                  />
               </div>
            ))}
         </div>
      </>
   );
};

export default PrescriptionFamilyGroupList;
